import React from 'react';
import dayjs from 'dayjs';
import { Card } from '@avila-tek/ui';
import { Title } from '../../shared';
import { OrderPayment } from '../../../models';
import { orderPaymentStatusTranslate } from '../../../static/orderStatus';
import { PAYMENT_STATUS_COLOR } from '../../../constants/constants';
import Badge from '../../shared/Badge';

interface OrderPaymentInfoProps {
  order: OrderPayment;
}

function OrderPaymentInfo({ order }: OrderPaymentInfoProps) {
  const [colorStatus, setSetColorStatus] = React.useState('');
  React.useEffect(() => {
    const colorClass = `${
      PAYMENT_STATUS_COLOR.find((option) => option.text === order.paymentStatus)
        ?.color
    }`;
    setSetColorStatus(colorClass);
  }, [order]);
  return (
    <Card className="p-4 sm:px-6 relative">
      <div className="space-y-1 flex flex-col">
        <Title title="Detalles de la orden" />
        <span className="text-neutral-warm-500">Pedido realizado</span>
        <span className="text-text-gray text-lg font-semibold">
          {dayjs(order.createdAt).format('L')}
        </span>
        <span className="text-neutral-warm-500">Estatus</span>
        <Badge
          bgClassName={`bg-${colorStatus}-100 `}
          textClassName={`text-${colorStatus}-300 `}
          text={orderPaymentStatusTranslate[order.paymentStatus]}
        />
      </div>
    </Card>
  );
}

export default OrderPaymentInfo;
